module.exports = __webpack_public_path__ + "img/vegetable-snow-peas-190x100.871423d2.jpg";